import type * as React from "react";

import { cn } from "../lib/cn";

export interface SlotStripProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "children"
> {
  /** Mono caps line naming what the strip is ("THU OCT 16 · DR. LEE"). */
  label?: React.ReactNode;
  /** Right of the label: the view toggle on a drawing's first strip. */
  aside?: React.ReactNode;
  columns: number;
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

/** One row of a drawn calendar: equal columns of `SlotCell`s under a label. */
export function SlotStrip({
  label,
  aside,
  columns,
  children,
  className,
  ...rest
}: SlotStripProps) {
  return (
    <div {...rest} className={cn("flex flex-col gap-1.5", className)}>
      {(label != null || aside != null) && (
        <div className="flex min-h-6 items-center justify-between gap-3">
          <span className="min-w-0 truncate text-mono-caps text-fine-print text-annotation">
            {label}
          </span>
          {aside != null && <span className="shrink-0">{aside}</span>}
        </div>
      )}
      <div
        className="grid gap-1.5"
        style={{
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
